import Cookies from 'js-cookie';
import get from 'lodash.get';
import { site } from '@panel/commons/helpers';

/**
 * Mapa de relación entre errores de MP
 * y los name de cada campo correspondiente
 */
const MPErrorCodes = {
  E301: 'cardNumber',
  E302: 'securityCode',
  '316': 'cardholderName',
  '324': 'docNumber',
  '325': 'cardExpiration',
  '326': 'cardExpiration',
  E205: 'cardExpiration'
};

const initialFormAttributes = {
  frequencyId: '57',
  issuerId: null,
  issuerName: null,
  cft: '0%',
  tea: '0%',
  paymentMethodId: null
};

const headers = {
  'X-NAVENT-APP': 'publicador',
  'Access-Control-Allow-Origin': window.location.origin,
  'x-panel-portal': site.id,
  sessionId: Cookies.get('sessionId')
};

const setIssuerFromResponse = (response, setState) => {
  const issuer = get(response[0], 'issuer', null);
  if (issuer) {
    const { id, name } = issuer;
    setState(previous => ({ ...previous, issuerId: id, issuerName: name }));
  }
};

const getBillingInfo = data => {
  const billingData = {
    legalName: data.userName,
    dni: data.userTaxCondition ? null : data.userDocument,
    address: data.address || null,
    postalCode: data.postalCode || null,
    taxCondition: data.userTaxCondition || null,
    ecommerceTaxId: data.userTaxCondition ? data.userDocument : null,
    locationId: data.locationSubZone || data.locationZone || data.locationCity || data.locationState
  };
  return billingData;
};

const sendCheckoutDataLayer = product => {
  window.dataLayer.push({
    event: 'checkout',
    ecommerce: {
      checkout: {
        actionField: { step: 1 },
        products: [
          {
            id: product.id,
            name: product.name,
            price: product.unitPrice,
            category: 'Aviso Particulares'
          }
        ]
      },
      flow_type: 'particular'
    }
  });
};

export { MPErrorCodes, initialFormAttributes, headers, setIssuerFromResponse, getBillingInfo, sendCheckoutDataLayer };
